module.exports = __webpack_public_path__ + "static/media/5.c72b9e12.png";